import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Button,
} from "@heroui/react";
import { Download, FileSpreadsheet, FileText, FileType } from "lucide-react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

const FORMAT_OPTIONS = [
  {
    key: "excel",
    label: "Excel",
    icon: <FileSpreadsheet size={14} className="text-gray-600 dark:text-gray-400" />,
  },
  {
    key: "pdf",
    label: "PDF",
    icon: <FileText size={14} className="text-gray-600 dark:text-gray-400" />,
  },
  {
    key: "doc",
    label: "Docs",
    icon: <FileType size={14} className="text-gray-600 dark:text-gray-400" />,
  },
];

const ExportDropdownButton = ({
  onExport,
  disabled = false,
  title = "Export",
  className = "",
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (format) => {
    if (disabled || isExporting) return;
    setIsExporting(true);
    try {
      await onExport?.(format);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Dropdown
      className="rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm min-w-[140px]"
      isDisabled={disabled || isExporting}
    >
      <DropdownTrigger>
        <Button
          className={cn(
            "px-[14px] py-[8px] gap-[6px] h-fit flex bg-white dark:bg-gray-800 items-center justify-center text-xs font-semibold shadow-sm border border-gray-300 dark:border-gray-700 rounded-lg text-gray-700 dark:text-gray-100",
            className,
          )}
          isDisabled={disabled}
          isLoading={isExporting}
          size="sm"
        >
          {!isExporting ? <Download size={16} className="text-gray-700 dark:text-gray-300" /> : null}
          {title}
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Export formats"
        className="text-xs text-gray-800 dark:text-gray-100 font-sans"
        onAction={(key) => handleExport(String(key))}
      >
        {FORMAT_OPTIONS.map((option) => (
          <DropdownItem
            key={option.key}
            textValue={option.label}
            className="hover:bg-[#207C9733] data-[hover=true]:bg-[#207C9733] data-[hover=true]:!text-secondary hover:!text-secondary text-gray-800 dark:text-gray-100"
          >
            <div className="flex items-center gap-2 text-xs">
              {option.icon}
              {option.label}
            </div>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default ExportDropdownButton;
